


export const GETADMINDATAREQUEST = "GETADMINDATAREQUEST"
export const GETADMINDATASUCCESS = "GETADMINDATASUCCESS"
export const GETADMINDATAFAILURE = "GETADMINDATAFAILURE"